module.exports = __webpack_public_path__ + "static/media/monsterdraw.00375afb.mp3";